import api from '@/utils/api'

export default {
  state: () => ({
    contractors: null,
    contractorStates: [],
    contractorAdminStatuses: {},
  }),
  mutations: {
    setContractors(state, payload) {
      state.contractors = payload
    },
    setContractorStates(state, payload) {
      state.contractorStates = payload
    },
    setContractorAdminStatuses(state, payload) {
      state.contractorAdminStatuses = payload
    },
  },
  getters: {
    contractorStatesTransformed: state => {
      return state.contractorStates.map(item => {
        return {
          key: item,
          label: item,
        }
      })
    },
    getContractorAdminStatusByKey: state => {
      return key => {
        return state.contractorAdminStatuses[key] || ''
      }
    },
    contractorAdminStatusesTransformed: state => {
      return Object.entries(state.contractorAdminStatuses).map(([key, value]) => {
        return {
          key: key,
          label: value,
        }
      })
    },
  },
  actions: {
    async fetchContractors({commit}, params) {
      if (params?.search === '') {
        delete params.search
      }

      if (params?.admin_status === 'Любой') {
        params.admin_status = null
      }

      const res = await api.http.get('/admin/contractors', {params})
      commit('setContractors', res?.data)
    },
    async fetchContractor(_, id) {
      const res = await api.http.get(`admin/contractors/${id}`)
      return res?.data?.data
    },
    async fetchContractorStates({commit}) {
      const res = await api.http.get('admin/contractors/states')
      commit('setContractorStates', res?.data)
    },
    async fetchContractorAdminStatuses({commit}) {
      const res = await api.http.get('admin/contractors/admin-statuses')
      commit('setContractorAdminStatuses', res?.data)
    },
    async changeContractorState(_, id) {
      const res = await api.http.get(`admin/contractors/approve/${id}`)
      return res?.data?.data
    },
    async changeContractorTopStatus(_, {id, params}) {
      const res = await api.http.put(`admin/contractors/${id}/top`, params)
      return res?.data?.data
    },
    async changeContractorRecommendStatus(_, {id, params}) {
      const res = await api.http.put(`admin/contractors/${id}/recommended`, params)
      return res?.data?.data
    },
    async changeContractorPosition(_, {id, params}) {
      const res = await api.http.put(`admin/contractors/${id}/position`, params)
      return res?.data?.data
    },
    async deleteContractor(_, id) {
      const res = await api.http.delete(`admin/contractors/${id}`)
      return res?.data?.data
    },
    async updatePhone(_, {phone, id}) {
      const res = await  api.http.put(`admin/contractors/${id}/phone`, {phone})
      return res?.data?.data
    },
    async fetchContractorCategories() {
      const res = await api.http.get('tree-categories')
      return res?.data?.data
    },
    async updateContractorCategory(_, { contractorId, categoryId }) {
      const res = await api.http.put(`admin/contractors/${contractorId}/category`, {category_id: categoryId})
      return res?.data?.data
    },
    async saveAdminStatus(_, {id, status}) {
      await api.http.post(`admin/contractors/${id}/change-status`, {'admin_status': status})
    },
    async saveDescription(_, {id, description}) {
      await api.http.post(`admin/contractors/${id}/save-description`, {'description': description})
    },
    async saveAvatar(_, {id, avatar}) {
      await api.http.post(`admin/contractors/${id}/save-avatar`, {'avatar': avatar})

    },
    async saveContractorServices(_, {id, contractorServices}) {
      const res = await api.http.post(`admin/contractors/${id}/save-contractor-services`, {'contractorServices': contractorServices})
      return res?.data?.data
    },
    async deleteContractorService(_, {id}) {
      const res = await api.http.delete(`admin/contractors/delete-contractor-services/${id}`)
      return res?.data?.data
    },
    async uploadImage(_, file) {
      const res = await api.http.post('/admin/contractors/portfolio/upload-image', file)
      return res?.data.data
    },
    async saveContractorPortfolio(_, {id, data}) {
      const res = await api.http.post(`admin/contractors/${id}/portfolio/save-contractor-portfolio`, data)
      return res?.data?.data
    },
    async saveWorkExamples(_, {id, workExamples}) {
      const res = await api.http.post(`admin/contractors/${id}/work-examples/save-work-examples`, {'workExamples': workExamples})
      return res?.data?.data
    },
    async deleteWorkExample(_, {id}) {
      const res = await api.http.delete(`admin/contractors/delete-work-example/${id}`)
      return res?.data?.data
    },
    async savePublicPhone(_, {id, publicPhone}) {
      await api.http.post(`admin/contractors/${id}/save-public-phone`, {'publicPhone': publicPhone})
    },
    async saveUsername(_, {id, username}) {
      await api.http.post(`admin/contractors/${id}/save-username`, {'username': username})
    },
  },
  namespaced: true,
}
